var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeature3Icon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2557)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4681 5.96573C14.4681 5.17517 15.109 4.5343 15.8995 4.5343H26.3967C27.1873 4.5343 27.8281 5.17517 27.8281 5.96573C27.8281 6.7563 27.1873 7.39717 26.3967 7.39717H15.8995C15.109 7.39717 14.4681 6.7563 14.4681 5.96573Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.10805 14.5543C1.10805 13.7637 1.74892 13.1229 2.53949 13.1229H20.671C21.4616 13.1229 22.1025 13.7637 22.1025 14.5543C22.1025 15.3449 21.4616 15.9857 20.671 15.9857H2.53949C1.74892 15.9857 1.10805 15.3449 1.10805 14.5543Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.10805 23.143C1.10805 22.3524 1.74892 21.7115 2.53949 21.7115H25.4425C26.233 21.7115 26.8739 22.3524 26.8739 23.143C26.8739 23.9336 26.233 24.5744 25.4425 24.5744H2.53949C1.74892 24.5744 1.10805 23.9336 1.10805 23.143Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9197 15.9857C26.7102 15.9857 27.3511 15.3449 27.3511 14.5543C27.3511 13.7637 26.7102 13.1229 25.9197 13.1229C25.1291 13.1229 24.4882 13.7637 24.4882 14.5543C24.4882 15.3449 25.1291 15.9857 25.9197 15.9857Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.63086,
    y: 3.63309,
    width: 9.45117,
    height: 4.66504,
    rx: 2.33252,
    stroke: "black",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2557"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.1973,
    height: 27.1973,
    fill: "white",
    transform: "translate(0.630859 0.44873)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeature3Icon1);
export default __webpack_public_path__ + "static/media/feature3-icon-1.7f51f3ce103f6b40bc5137a048ecda87.svg";
export { ForwardRef as ReactComponent };